<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  loading: { type: Boolean, default: false },
  result: { type: Object, default: null },
});

const { t } = useI18n();
const available = computed(
  () => props.result?.state === 'available' && props.result?.status
);
const fallback = computed(() => {
  if (props.result?.state === 'incomplete') {
    return t('POST_SALE.STATUS_DETAILS.REGISTRY_STATUS.INCOMPLETE');
  }
  if (props.result?.state === 'not_configured') {
    return t('POST_SALE.STATUS_DETAILS.REGISTRY_STATUS.NOT_CONFIGURED');
  }
  if (['not_available', 'unavailable'].includes(props.result?.state)) {
    return t('POST_SALE.STATUS_DETAILS.REGISTRY_STATUS.UNAVAILABLE');
  }

  return t('POST_SALE.STATUS_DETAILS.REGISTRY_STATUS.PENDING');
});
const statusClass = computed(() =>
  props.result?.exigencia
    ? 'bg-lais-danger/10 text-lais-danger'
    : 'bg-lais-success/10 text-lais-success'
);
</script>

<template>
  <div
    data-testid="post-sale-registry-status"
    class="flex flex-wrap items-center gap-x-2 gap-y-1 bg-white px-[15px] py-[10px] text-[14px] text-lais-text-muted"
  >
    <span>
      {{ t('POST_SALE.STATUS_DETAILS.REGISTRY_STATUS.TITLE') }}
    </span>
    <span
      v-if="loading"
      data-testid="post-sale-registry-status-loading"
      class="h-5 w-[280px] max-w-full animate-pulse rounded bg-lais-primary-50"
    />
    <template v-else-if="available">
      <span>{{ t('POST_SALE.STATUS_DETAILS.REGISTRY_STATUS.STATUS') }}</span>
      <span
        data-testid="post-sale-registry-status-chip"
        class="h-[18px] rounded-[4px] px-1.5 text-[12px] font-normal uppercase leading-[18px]"
        :class="statusClass"
      >
        {{ result.status }}
      </span>
      <p v-if="result.exigencia" class="basis-full sm:basis-auto">
        {{
          t('POST_SALE.STATUS_DETAILS.REGISTRY_STATUS.EXIGENCY', {
            text: result.exigencia,
          })
        }}
      </p>
    </template>
    <p v-else data-testid="post-sale-registry-status-fallback">
      {{ fallback }}
    </p>
  </div>
</template>
